(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-accordion-covers"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionAccordionCovers(root = document) {
    root.querySelectorAll('[data-collection-accordion-covers]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      if (window.CurtisMedia) window.CurtisMedia.initialize(section);

      const stage = section.querySelector('.lens-stage');
      const panels = Array.from(section.querySelectorAll('[data-collection-accordion-panel]'));
      if (!stage || panels.length === 0) return;

      let titleFitQueued = false;
      let boundaryTouch = null;
      let boundaryScrollFrame = 0;
      let pendingBoundaryScrollTop = null;
      const compactReelQuery = window.matchMedia(
        '(max-width: 749px), (min-width: 750px) and (max-width: 1199px) and (orientation: portrait)'
      );
      const precisionPointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      const compactPanels = panels
        .slice()
        .sort((a, b) => Number(a.dataset.phoneOrder || 0) - Number(b.dataset.phoneOrder || 0));
      const lastCompactPanel = compactPanels[compactPanels.length - 1];
      const scrollingElement = document.scrollingElement || document.documentElement;
      const progressCurrent = section.querySelector('[data-reel-progress-current]');
      const swipeCue = section.querySelector('[data-reel-swipe-cue]');
      const swipeCueText = swipeCue?.querySelector('[data-reel-swipe-cue-text]');
      let wheelAccumulator = 0;
      let wheelDirection = 0;
      let wheelResetTimer = 0;
      let wheelCooldownUntil = 0;

      const formatPanelNumber = (value) => String(value).padStart(2, '0');

      const updateReelChrome = (activePanel) => {
        const activeIndex = compactPanels.indexOf(activePanel);
        if (activeIndex < 0) return;

        if (progressCurrent) progressCurrent.textContent = formatPanelNumber(activeIndex + 1);
        if (!swipeCue || !swipeCueText) return;

        const defaultText = swipeCueText.dataset.defaultText || '';
        const finalText = swipeCueText.dataset.finalText || defaultText;

        swipeCueText.textContent = activeIndex > 0 ? finalText : defaultText;
      };

      const syncStageTabIndex = () => {
        stage.tabIndex = compactReelQuery.matches ? 0 : -1;
      };

      const scrollToCompactPanel = (panel, focusLink = false) => {
        if (!panel) return;
        setActivePanel(panel);
        stage.scrollTo({ top: panel.offsetTop, behavior: 'smooth' });

        if (focusLink) {
          const panelLink = panel.querySelector('a[href]');
          panelLink?.focus({ preventScroll: true });
        }
      };

      const resetWheelAccumulator = () => {
        if (wheelResetTimer) window.clearTimeout(wheelResetTimer);
        wheelResetTimer = 0;
        wheelAccumulator = 0;
        wheelDirection = 0;
      };

      const handlePrecisionWheel = (event) => {
        if (!compactReelQuery.matches || !precisionPointerQuery.matches || event.ctrlKey) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        const deltaMultiplier = event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? stage.clientHeight
            : 1;
        const normalizedDelta = event.deltaY * deltaMultiplier;
        const direction = Math.sign(normalizedDelta);
        if (!direction) return;

        const activePanel = panels.find((panel) => panel.classList.contains('is-active')) || compactPanels[0];
        const activeIndex = Math.max(0, compactPanels.indexOf(activePanel));
        const leavingBeforeFirst = direction < 0 && activeIndex === 0 && stage.scrollTop <= 1;
        const stageEnd = Math.max(0, stage.scrollHeight - stage.clientHeight);
        const leavingAfterLast = direction > 0
          && activeIndex === compactPanels.length - 1
          && stage.scrollTop >= stageEnd - 1;

        if (leavingBeforeFirst || leavingAfterLast) {
          resetWheelAccumulator();
          return;
        }

        event.preventDefault();

        const now = window.performance.now();
        if (now < wheelCooldownUntil) return;

        if (wheelDirection && wheelDirection !== direction) wheelAccumulator = 0;
        wheelDirection = direction;
        wheelAccumulator += normalizedDelta;

        if (wheelResetTimer) window.clearTimeout(wheelResetTimer);
        wheelResetTimer = window.setTimeout(resetWheelAccumulator, 240);

        if (Math.abs(wheelAccumulator) < 96) return;

        const targetIndex = Math.min(
          compactPanels.length - 1,
          Math.max(0, activeIndex + direction)
        );

        resetWheelAccumulator();
        wheelCooldownUntil = now + 680;
        scrollToCompactPanel(compactPanels[targetIndex]);
      };

      const handleReelKeydown = (event) => {
        if (!compactReelQuery.matches) return;

        const focusedPanel = event.target.closest?.('[data-collection-accordion-panel]');
        const activePanel = focusedPanel
          || panels.find((panel) => panel.classList.contains('is-active'))
          || compactPanels[0];
        const activeIndex = Math.max(0, compactPanels.indexOf(activePanel));
        const focusLink = event.target !== stage;
        let targetIndex = activeIndex;

        if (event.key === 'ArrowDown' || event.key === 'PageDown') {
          if (activeIndex === compactPanels.length - 1) {
            const nextSectionTop = getNextSectionTop();
            if (nextSectionTop === null) return;
            event.preventDefault();
            scrollingElement.scrollTo({ top: nextSectionTop, behavior: 'smooth' });
            return;
          }
          targetIndex = activeIndex + 1;
        } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
          if (activeIndex === 0) return;
          targetIndex = activeIndex - 1;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = compactPanels.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        scrollToCompactPanel(compactPanels[targetIndex], focusLink);
      };

      syncStageTabIndex();
      compactReelQuery.addEventListener('change', syncStageTabIndex);
      stage.addEventListener('keydown', handleReelKeydown);
      stage.addEventListener('wheel', handlePrecisionWheel, { passive: false });

      const discardBoundaryScrollFrame = () => {
        if (boundaryScrollFrame) window.cancelAnimationFrame(boundaryScrollFrame);
        boundaryScrollFrame = 0;
        pendingBoundaryScrollTop = null;
      };

      const flushBoundaryScroll = () => {
        if (boundaryScrollFrame) window.cancelAnimationFrame(boundaryScrollFrame);
        boundaryScrollFrame = 0;

        if (pendingBoundaryScrollTop === null) return;
        scrollingElement.scrollTop = pendingBoundaryScrollTop;
        pendingBoundaryScrollTop = null;
      };

      const queueBoundaryScroll = (top) => {
        pendingBoundaryScrollTop = Math.max(0, top);
        if (boundaryScrollFrame) return;

        boundaryScrollFrame = window.requestAnimationFrame(() => {
          boundaryScrollFrame = 0;
          if (pendingBoundaryScrollTop === null) return;
          scrollingElement.scrollTop = pendingBoundaryScrollTop;
          pendingBoundaryScrollTop = null;
        });
      };

      const restoreBoundaryStyles = (touch = boundaryTouch) => {
        stage.classList.remove('is-boundary-handoff');
        if (touch?.rootScrollBehavior !== undefined) {
          scrollingElement.style.scrollBehavior = touch.rootScrollBehavior;
        }
      };

      const resetBoundaryTouch = () => {
        discardBoundaryScrollFrame();
        restoreBoundaryStyles();
        boundaryTouch = null;
      };

      const getNextSectionTop = () => {
        const sectionWrapper = section.closest('.shopify-section') || section;
        const nextSection = sectionWrapper.nextElementSibling;
        if (!nextSection) return null;

        const headerHeight = parseFloat(
          window.getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')
        ) || 0;

        return Math.max(0, nextSection.getBoundingClientRect().top + window.scrollY - headerHeight);
      };

      const handleBoundaryTouchStart = (event) => {
        resetBoundaryTouch();
        if (!compactReelQuery.matches || event.touches.length !== 1) {
          return;
        }

        const touch = event.touches[0];
        const stageEnd = Math.max(0, stage.scrollHeight - stage.clientHeight);
        const lastPanelIsCurrent = stage.scrollTop >= stageEnd - (stage.clientHeight / 2);
        if (!lastPanelIsCurrent) return;

        boundaryTouch = {
          x: touch.clientX,
          y: touch.clientY,
          windowY: window.scrollY,
          stageEnd,
          direction: null,
          handoffStarted: false,
          lastDeltaY: 0,
          lastMoveWasUpward: false,
          previousY: touch.clientY,
          previousTime: event.timeStamp || window.performance.now(),
          velocity: 0,
          rootScrollBehavior: undefined
        };
      };

      const handleBoundaryTouchMove = (event) => {
        if (!boundaryTouch || event.touches.length !== 1) return;

        const touch = event.touches[0];
        const deltaY = boundaryTouch.y - touch.clientY;
        const deltaX = Math.abs(boundaryTouch.x - touch.clientX);
        const absoluteDeltaY = Math.abs(deltaY);

        boundaryTouch.lastDeltaY = deltaY;
        boundaryTouch.lastMoveWasUpward = deltaY > 0 && absoluteDeltaY > deltaX;

        if (!boundaryTouch.direction) {
          if (boundaryTouch.lastMoveWasUpward && event.cancelable) event.preventDefault();
          if (Math.max(deltaX, absoluteDeltaY) < 10) return;

          boundaryTouch.direction = boundaryTouch.lastMoveWasUpward ? 'up' : 'other';
        }

        if (boundaryTouch.direction !== 'up' || !boundaryTouch.lastMoveWasUpward || !event.cancelable) return;

        event.preventDefault();

        if (!boundaryTouch.handoffStarted) {
          boundaryTouch.handoffStarted = true;
          boundaryTouch.rootScrollBehavior = scrollingElement.style.scrollBehavior;
          scrollingElement.style.scrollBehavior = 'auto';
          stage.classList.add('is-boundary-handoff');
          stage.scrollTop = boundaryTouch.stageEnd;
        }

        const now = event.timeStamp || window.performance.now();
        const elapsed = Math.max(1, now - boundaryTouch.previousTime);
        const instantVelocity = (boundaryTouch.previousY - touch.clientY) / elapsed;
        boundaryTouch.velocity = (boundaryTouch.velocity * 0.68) + (instantVelocity * 0.32);
        boundaryTouch.previousY = touch.clientY;
        boundaryTouch.previousTime = now;

        queueBoundaryScroll(boundaryTouch.windowY + deltaY);
      };

      const handleBoundaryTouchEnd = () => {
        if (!boundaryTouch) return;

        const touch = boundaryTouch;
        flushBoundaryScroll();
        restoreBoundaryStyles(touch);
        boundaryTouch = null;

        if (!touch.handoffStarted) return;

        const meaningfulRelease = touch.lastMoveWasUpward
          && (touch.lastDeltaY >= 36 || touch.velocity >= 0.32);
        const nextSectionTop = getNextSectionTop();
        const targetTop = meaningfulRelease && nextSectionTop !== null
          ? nextSectionTop
          : touch.windowY;

        scrollingElement.scrollTo({ top: targetTop, behavior: 'smooth' });
      };

      if (lastCompactPanel) {
        lastCompactPanel.addEventListener('touchstart', handleBoundaryTouchStart, { passive: true });
        lastCompactPanel.addEventListener('touchmove', handleBoundaryTouchMove, { passive: false });
        lastCompactPanel.addEventListener('touchend', handleBoundaryTouchEnd, { passive: true });
        lastCompactPanel.addEventListener('touchcancel', resetBoundaryTouch, { passive: true });
      }

      window.CurtisTheme?.registerCleanup?.(section, () => {
        resetBoundaryTouch();
        resetWheelAccumulator();
        compactReelQuery.removeEventListener('change', syncStageTabIndex);
        stage.removeEventListener('keydown', handleReelKeydown);
        stage.removeEventListener('wheel', handlePrecisionWheel);
        if (!lastCompactPanel) return;
        lastCompactPanel.removeEventListener('touchstart', handleBoundaryTouchStart);
        lastCompactPanel.removeEventListener('touchmove', handleBoundaryTouchMove);
        lastCompactPanel.removeEventListener('touchend', handleBoundaryTouchEnd);
        lastCompactPanel.removeEventListener('touchcancel', resetBoundaryTouch);
      });

      const fitSingleLineText = (title, frame, minSize = 16) => {
        if (!title || !frame) return;

        title.style.fontSize = '';

        const frameWidth = frame.getBoundingClientRect().width;
        const titleBoxWidth = title.getBoundingClientRect().width;
        const availableWidth = Math.min(frameWidth || titleBoxWidth, titleBoxWidth || frameWidth);
        const titleWidth = title.scrollWidth;
        const fontSize = parseFloat(window.getComputedStyle(title).fontSize);
        if (!availableWidth || !titleWidth || !fontSize || titleWidth <= availableWidth) return;

        const nextSize = Math.max(minSize, Math.floor((fontSize * (availableWidth / titleWidth)) * 100) / 100);
        title.style.fontSize = `${nextSize}px`;
      };

      const fitPanelTitles = () => {
        const introTitle = section.querySelector('.accordion-intro h2');
        if (introTitle) fitSingleLineText(introTitle, introTitle.closest('.accordion-intro'), 16);

        panels.forEach((panel) => {
          const title = panel.querySelector('.luxury-title h2');
          const titleFrame = title?.closest('.luxury-title');
          fitSingleLineText(title, titleFrame, 16);
        });
      };

      const queueTitleFit = () => {
        if (titleFitQueued) return;
        titleFitQueued = true;

        window.requestAnimationFrame(() => {
          titleFitQueued = false;
          fitPanelTitles();
        });
      };

      const setActivePanel = (activePanel) => {
        panels.forEach((panel) => panel.classList.toggle('is-active', panel === activePanel));
        updateReelChrome(activePanel);
      };

      const setInitialActivePanel = () => {
        if (!window.matchMedia('(max-width: 749px), (min-width: 750px) and (max-width: 1199px) and (orientation: portrait)').matches) return;

        const firstPhonePanel = panels
          .slice()
          .sort((a, b) => Number(a.dataset.phoneOrder || 0) - Number(b.dataset.phoneOrder || 0))[0];

        if (firstPhonePanel) setActivePanel(firstPhonePanel);
      };

      setInitialActivePanel();
      queueTitleFit();

      if (document.fonts?.ready) {
        document.fonts.ready.then(queueTitleFit);
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(queueTitleFit);
        resizeObserver.observe(stage);
        const introTitle = section.querySelector('.accordion-intro h2');
        if (introTitle) resizeObserver.observe(introTitle);
        panels.forEach((panel) => resizeObserver.observe(panel));
        window.CurtisTheme?.registerCleanup?.(section, () => resizeObserver.disconnect());
      } else {
        window.addEventListener('resize', queueTitleFit);
        window.CurtisTheme?.registerCleanup?.(section, () => window.removeEventListener('resize', queueTitleFit));
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const activeEntry = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

            if (activeEntry) setActivePanel(activeEntry.target);
          },
          {
            root: stage,
            threshold: [0.55, 0.72, 0.9]
          }
        );

        panels.forEach((panel) => observer.observe(panel));
        window.CurtisTheme?.registerCleanup?.(section, () => observer.disconnect());
      }

      section.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-collection-accordion-panel]');
        if (!panel) return;

        setActivePanel(panel);
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  initializeCollectionAccordionCovers();
  document.addEventListener('shopify:section:load', (event) => initializeCollectionAccordionCovers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-rail"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionProductRail(root = document) {
    root.querySelectorAll('[data-collection-product-rail]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const viewport = section.querySelector('[data-rail-viewport]');
      const previous = section.querySelector('[data-rail-prev]');
      const next = section.querySelector('[data-rail-next]');
      if (!viewport || !previous || !next) return;

      const updateButtons = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth - 2;
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maxScroll;
      };

      const scrollByPage = (direction) => {
        const amount = Math.max(viewport.clientWidth * 0.82, 240);
        viewport.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      viewport.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      window.CurtisTheme?.registerCleanup?.(section, () => window.removeEventListener('resize', updateButtons));
      updateButtons();
    });
  }

  initializeCollectionProductRail();
  document.addEventListener('shopify:section:load', (event) => initializeCollectionProductRail(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtis-world-teaser"] && !Shopify.designMode) return;
  try {
    
  function initializeCurtisWorldTeaser(root = document) {
    root.querySelectorAll('[data-curtis-world-teaser]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeCurtisWorldTeaser();
  document.addEventListener('shopify:section:load', (event) => initializeCurtisWorldTeaser(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-invitation"] && !Shopify.designMode) return;
  try {
    
  function initializeFinalInvitation(root = document) {
    root.querySelectorAll('[data-final-invitation]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeFinalInvitation();
  document.addEventListener('shopify:section:load', (event) => initializeFinalInvitation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initializeHeaderSearch(root = document) {
    root.querySelectorAll('[data-search-modal]').forEach((modal) => {
      if (modal.dataset.searchInitialized === 'true') return;
      modal.dataset.searchInitialized = 'true';

      const openers = document.querySelectorAll(`[data-search-modal-open][aria-controls="${modal.id}"]`);
      const closeButtons = modal.querySelectorAll('[data-search-modal-close]');
      const input = modal.querySelector('[data-predictive-search-input]');
      let activeElement = null;

      const open = () => {
        activeElement = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('drawer-open');
        window.setTimeout(() => input?.focus(), 0);
      };

      const close = () => {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('drawer-open');
        activeElement?.focus?.();
      };

      openers.forEach((opener) => opener.addEventListener('click', open));
      closeButtons.forEach((button) => button.addEventListener('click', close));

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (window.CurtisTheme?.trapFocus) window.CurtisTheme.trapFocus(modal, event);
      });
    });
  }

  initializeHeaderSearch();
  document.addEventListener('shopify:section:load', (event) => initializeHeaderSearch(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  function initializeMainSearchFacets(root = document) {
    root.querySelectorAll('.main-search .facets').forEach((form) => {
      if (form.dataset.searchFacetsInitialized === 'true') return;
      form.dataset.searchFacetsInitialized = 'true';

      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (input.value.trim() === '') input.disabled = true;
        });
      });
    });
  }

  initializeMainSearchFacets();
  document.addEventListener('shopify:section:load', (event) => initializeMainSearchFacets(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-you-editorial"] && !Shopify.designMode) return;
  try {
    
  function initializeMoreYouEditorial(root = document) {
    root.querySelectorAll('[data-more-you-editorial]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);

      const desktopLayout = window.matchMedia('(min-width: 750px)');
      let titleFitQueued = false;

      const fitTextToWidth = (title, frame, minSize = 11) => {
        if (!title || !frame) return;

        title.style.fontSize = '';

        const frameStyle = window.getComputedStyle(frame);
        const frameWidth = frame.getBoundingClientRect().width
          - parseFloat(frameStyle.paddingLeft || 0)
          - parseFloat(frameStyle.paddingRight || 0);
        const titleBoxWidth = title.getBoundingClientRect().width;
        const availableWidth = Math.min(frameWidth || titleBoxWidth, titleBoxWidth || frameWidth);
        const titleWidth = title.scrollWidth;
        const fontSize = parseFloat(window.getComputedStyle(title).fontSize);
        if (!availableWidth || !titleWidth || !fontSize || titleWidth <= availableWidth) return;

        let nextSize = fontSize;
        for (let attempt = 0; attempt < 8 && title.scrollWidth > availableWidth + 1 && nextSize > minSize; attempt += 1) {
          const currentWidth = title.scrollWidth || titleWidth;
          nextSize = Math.max(minSize, Math.floor((nextSize * (availableWidth / currentWidth) * 0.98) * 100) / 100);
          title.style.fontSize = `${nextSize}px`;
        }
      };

      const fitReasonTitles = () => {
        const titles = Array.from(section.querySelectorAll('.more-you-editorial__reason h3'));
        titles.forEach((title) => {
          title.style.fontSize = '';
        });

        fitTextToWidth(section.querySelector('.more-you-editorial--midnight h2'), section.querySelector('.more-you-editorial--midnight .more-you-editorial__intro-copy'), 22);

        if (!section.classList.contains('more-you-editorial--midnight') || !desktopLayout.matches) return;

        titles.forEach((title) => {
          fitTextToWidth(title, title.closest('.more-you-editorial__reason-head'), 11);
        });
      };

      const queueTitleFit = () => {
        if (titleFitQueued) return;
        titleFitQueued = true;

        window.requestAnimationFrame(() => {
          titleFitQueued = false;
          fitReasonTitles();
        });
      };

      queueTitleFit();

      if (document.fonts?.ready) {
        document.fonts.ready.then(queueTitleFit);
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(queueTitleFit);
        resizeObserver.observe(section);
        const introCopy = section.querySelector('.more-you-editorial__intro-copy');
        if (introCopy) resizeObserver.observe(introCopy);
        section.querySelectorAll('.more-you-editorial__reason-head').forEach((reasonHead) => {
          resizeObserver.observe(reasonHead);
        });
        window.CurtisTheme?.registerCleanup?.(section, () => resizeObserver.disconnect());
      } else {
        window.addEventListener('resize', queueTitleFit);
        window.CurtisTheme?.registerCleanup?.(section, () => window.removeEventListener('resize', queueTitleFit));
      }
    });
  }

  initializeMoreYouEditorial();
  document.addEventListener('shopify:section:load', (event) => initializeMoreYouEditorial(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presence-finder"] && !Shopify.designMode) return;
  try {
    
  function initializePresenceFinder(root = document) {
    root.querySelectorAll('.presence-finder').forEach((section) => {
      if (section.dataset.presenceFinderInitialized === 'true') return;
      section.dataset.presenceFinderInitialized = 'true';

      let headingFitQueued = false;

      const fitTextToWidth = (title, frame, minSize = 24) => {
        if (!title || !frame) return;

        title.style.fontSize = '';

        const frameStyle = window.getComputedStyle(frame);
        const frameWidth = frame.getBoundingClientRect().width
          - parseFloat(frameStyle.paddingLeft || 0)
          - parseFloat(frameStyle.paddingRight || 0);
        const titleBoxWidth = title.getBoundingClientRect().width;
        const availableWidth = Math.min(frameWidth || titleBoxWidth, titleBoxWidth || frameWidth);
        const titleWidth = title.scrollWidth;
        const fontSize = parseFloat(window.getComputedStyle(title).fontSize);
        if (!availableWidth || !titleWidth || !fontSize || titleWidth <= availableWidth) return;

        const nextSize = Math.max(minSize, Math.floor((fontSize * (availableWidth / titleWidth)) * 100) / 100);
        title.style.fontSize = `${nextSize}px`;
      };

      const fitCardHeadings = () => {
        section.querySelectorAll('.presence-finder__card h3').forEach((title) => {
          fitTextToWidth(title, title.closest('.presence-finder__card-top'), 24);
        });
      };

      const queueHeadingFit = () => {
        if (headingFitQueued) return;
        headingFitQueued = true;

        window.requestAnimationFrame(() => {
          headingFitQueued = false;
          fitCardHeadings();
        });
      };

      queueHeadingFit();

      if (document.fonts?.ready) {
        document.fonts.ready.then(queueHeadingFit);
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(queueHeadingFit);
        resizeObserver.observe(section);
        section.querySelectorAll('.presence-finder__card-top').forEach((cardTop) => {
          resizeObserver.observe(cardTop);
        });
        window.CurtisTheme?.registerCleanup?.(section, () => resizeObserver.disconnect());
      } else {
        window.addEventListener('resize', queueHeadingFit);
        window.CurtisTheme?.registerCleanup?.(section, () => window.removeEventListener('resize', queueHeadingFit));
      }
    });
  }

  initializePresenceFinder();
  document.addEventListener('shopify:section:load', (event) => initializePresenceFinder(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  function initializeWatchCollectionEditorial(root = document) {
    root.querySelectorAll('[data-watch-collection-editorial]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeWatchCollectionEditorial();
  document.addEventListener('shopify:section:load', (event) => initializeWatchCollectionEditorial(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-collection-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeWatchCollectionHero(root = document) {
    root.querySelectorAll('[data-watch-collection-hero]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeWatchCollectionHero();
  document.addEventListener('shopify:section:load', (event) => initializeWatchCollectionHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-collection-moments"] && !Shopify.designMode) return;
  try {
    
  function initializeWatchCollectionMoments(root = document) {
    root.querySelectorAll('[data-watch-collection-moments]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeWatchCollectionMoments();
  document.addEventListener('shopify:section:load', (event) => initializeWatchCollectionMoments(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  function initializeWatchCollectionShowcase(root = document) {
    root.querySelectorAll('[data-watch-collection-showcase]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (window.CurtisMotion) window.CurtisMotion.initialize(section);
      if (window.CurtisMedia) window.CurtisMedia.initialize(section);
    });
  }

  initializeWatchCollectionShowcase();
  document.addEventListener('shopify:section:load', (event) => initializeWatchCollectionShowcase(event.target));

  } catch(e) { console.error(e); }
})();
})();
